
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../mocks/translations';

export default function Footer() {
  const { language } = useLanguage();
  const t = translations[language].footer;

  return (
    <footer className="bg-gradient-to-br from-teal-800 to-teal-900 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/e536622a-0947-470a-853b-93e6ddce8b2f.png" 
                alt="QIUTOMS ENERGY Logo" 
                className="h-10 w-auto object-contain"
              />
              <div>
                <h3 className="text-xl font-bold">QIUTOMS ENERGY</h3>
                <p className="text-xs text-gray-400">FZ-LLC</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed mb-4">
              {t.description}
            </p>
            <div className="flex items-center gap-3">
              <div className="px-3 py-1 bg-teal-600 rounded-md">
                <p className="text-xs font-medium">License: 5037142</p>
              </div>
              <div className="px-3 py-1 bg-emerald-600 rounded-md">
                <p className="text-xs font-medium">CWEP0549</p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#mission" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">{t.mission}</a>
              </li>
              <li>
                <a href="#license" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">{t.licenseInfo}</a>
              </li>
              <li>
                <a href="#company" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">{t.companyDetails}</a>
              </li>
              <li>
                <a href="#activity" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">{t.businessActivity}</a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">{t.contact}</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">{t.contactInfo}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span className="text-sm text-gray-300">Compass Building, Al Shohada Road, Ras Al Khaimah, UAE</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-building-line text-teal-400 mt-1"></i>
                <span className="text-sm text-gray-300">AL Hamra Industrial Zone-FZ</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <a href="mailto:info@qiutomsenergy.com" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  info@qiutomsenergy.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">
              {t.copyright}
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
